import styles from "./AgentEinsteinButton.module.css";
import { BorderAnimate } from "@gfazioli/mantine-border-animate";
import AgentIcon from "@lib/experiment/agent/AgentIcon";
import type { ActionIconProps } from "@mantine/core";
import { ActionIcon, Box, Tooltip } from "@mantine/core";

export default function AgentEinsteinButton({
  hide,
  onClick,
  ...props
}: { hide?: boolean; onClick: VoidFunction } & ActionIconProps) {
  return (
    <Tooltip label="AI chat assistance for your experiment" disabled={hide}>
      <Box className={styles.container} data-hide={hide ? true : undefined}>
        <BorderAnimate
          radius="xl"
          variant="beam"
          show={!hide}
          borderOpacity={0.5}
          borderWidth={1}
          duration={4.5}
          size="xs"
        >
          <ActionIcon
            variant="gradient"
            gradient={{ from: "var(--mantine-color-body)", to: "var(--mantine-color-blue-outline-hover)", deg: 180 }}
            classNames={{ root: styles.actionIcon }}
            radius="100%"
            p="xs"
            size="2.1rem"
            onClick={onClick}
            c="var(--mantine-color-bright)"
            {...props}
          >
            <AgentIcon size="1rem" />
          </ActionIcon>
        </BorderAnimate>
      </Box>
    </Tooltip>
  );
}
